<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'PWO_Title' | translateWF: 'Production Work Orders' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" (onClick)="redirectToDetails()" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'PWO_Title' | translateWF: 'Production Work Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="productionWorkOrders()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number">
                  {{ 'PWO_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="number"></p-sortIcon>
                </th>
                <th>{{ 'PWO_Status' | translateWF: 'Status' }}</th>
                <th class="text-center">{{ 'PWO_Items' | translateWF: 'Items' }}</th>
                <th pSortableColumn="estimatedStartDate">
                  {{ 'PWO_Estimated_Start' | translateWF: 'Est. Start' }}
                  <p-sortIcon field="estimatedStartDate"></p-sortIcon>
                </th>
                <th pSortableColumn="estimatedEndDate">
                  {{ 'PWO_Estimated_End' | translateWF: 'Est. End' }}
                  <p-sortIcon field="estimatedEndDate"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-pwo>
              <tr (click)="redirectToDetails(pwo.id)" class="cursor-pointer">
                <td class="font-medium">{{ pwo.number }}</td>
                <td>
                  <p-tag [value]="getStatusLabel(pwo.status)" [severity]="getStatusSeverity(pwo.status)" />
                </td>
                <td class="text-center">{{ pwo.items?.length || 0 }}</td>
                <td>{{ pwo.estimatedStartDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ pwo.estimatedEndDate | date: 'dd/MM/yyyy' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center py-8 text-gray-400">
                  {{ 'PWO_No_Records' | translateWF: 'No production work orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
